<template>
  <v-form v-model="formValid">
    <v-subheader class="font-italic font-weight-light py-1">Generale</v-subheader>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="code"  
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Nome"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="description"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Descrizione"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from 'vue'
import enablingTypeCategoryForm from '@/services/enablingTypeCategories/enablingTypeCategory.form.js'

export default {
  name: "GeneralFormTab",
  components: {},
  data: function() {
    return {
      code: undefined,
      description: undefined,
      loadingEnablingTypeCategory: false,
      formValid: false,
      max255CharRule: (v) => {
        if(v) {
          return v.length <= 255 || 'Al massimo 255 caratteri'
        } else {
          return true
        }
      },
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
    };
  },
  props: {
    bus: {
      type: Object,
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: function() {
    this.handleObjectChanges(enablingTypeCategoryForm.enablingTypeCategory)

    var self = this
    enablingTypeCategoryForm.on('update', function(data) {
      self.handleObjectChanges(data.enablingTypeCategory)
    })
  },
  methods: {
    fields() {
      return ['code', 'description']
    },
    handleObjectChanges(enablingTypeCategory) {
      const fields = this.fields()
      const newValKeys = Object.keys(enablingTypeCategory)

      for(let i = 0; i < fields.length; i++) {
        const field = fields[i]
        if(newValKeys.includes(field) && enablingTypeCategory[field] != this[field]) {
          this[field] = enablingTypeCategory[field]
        }
      }
    },
  },
  watch: {
    formValid(newVal) {
      this.$emit('update:valid', newVal)
      if(this.bus) {
        this.bus.$emit('update:valid', newVal)
      }
      enablingTypeCategoryForm.setValid(newVal)
    },
    code(newVal) {
      enablingTypeCategoryForm.updateField('code', newVal)
    },
    description(newVal) {
      enablingTypeCategoryForm.updateField('description', newVal)
    },
  }
};
</script>

<style></style>